import _ from 'lodash';

import { NAVIGATION } from '../../config';
import { goToPath } from '../../utils/navigation';

// TODO: move to file manager utils
export function goToFileManager(
  organizationId: string,
  projectId: string,
  path?: string | undefined | null,
  locateFileId?: string,
) {
  const isRootPath = !path || _.isEmpty(path) || _.trim(path) === '/';

  goToPath(
    NAVIGATION.FILE_MANAGER,
    { organizationId, projectId },
    { path: isRootPath ? undefined : path, locateFileId },
  );
}
